import { Stack, Title, Text, Button } from '@mantine/core';
import { VideoCallScaffold } from '../../DailyVideoCall';
import { IconAlertTriangle } from '@tabler/icons-react';
import { primaryColor } from '../../../../constants/theme';

export const VideoCallError = ({ message }: { message: string }) => {
  return (
    <VideoCallScaffold>
      <Stack justify="center" align="center" gap={10} h="100%">
        <IconAlertTriangle size={100} color="red" />
        <Title order={3} fw="normal">
          An error occurred during the video call.
        </Title>
        {message && (
          <Text fz="md" c="dimmed">
            {message}
          </Text>
        )}
        <Button
          fullWidth
          maw="400"
          onClick={() => window.location.reload()}
          mt={20}
          color={primaryColor}
        >
          Reload Page
        </Button>
      </Stack>
    </VideoCallScaffold>
  );
};
